import * as Dialog from '@radix-ui/react-dialog';
import { WarningCircle } from '@phosphor-icons/react';

interface ConfirmDialogProps {
  open: boolean;
  title: string;
  message: string;
  confirmLabel?: string;
  danger?: boolean;
  onConfirm: () => void;
  onCancel: () => void;
}

export default function ConfirmDialog({
  open,
  title,
  message,
  confirmLabel = 'Confirm',
  danger = false,
  onConfirm,
  onCancel,
}: ConfirmDialogProps) {
  return (
    <Dialog.Root open={open} onOpenChange={o => { if (!o) onCancel(); }}>
      <Dialog.Portal>
        <Dialog.Overlay className="fixed inset-0 bg-black/60 z-50" />
        <Dialog.Content
          className="fixed left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 z-50 w-full max-w-sm bg-bg-surface border border-border rounded-xl shadow-2xl p-6 focus:outline-none"
          onPointerDownOutside={e => e.preventDefault()}
        >
          <div className="flex items-start gap-3 mb-5">
            <div className={`shrink-0 w-9 h-9 rounded-full flex items-center justify-center ${danger ? 'bg-red-400/10' : 'bg-accent/10'}`}>
              <WarningCircle size={18} weight="fill" className={danger ? 'text-red-400' : 'text-accent'} />
            </div>
            <div>
              <Dialog.Title className="font-sans font-semibold text-sm text-text-primary mb-1">
                {title}
              </Dialog.Title>
              <Dialog.Description className="font-sans text-xs text-text-secondary leading-relaxed">
                {message}
              </Dialog.Description>
            </div>
          </div>

          <div className="flex gap-2 justify-end">
            <button
              onClick={onCancel}
              className="px-3.5 py-1.5 text-xs font-sans rounded bg-bg-input border border-border text-text-secondary hover:text-text-primary hover:border-border-subtle transition-colors"
            >
              Cancel
            </button>
            <button
              onClick={onConfirm}
              className={`px-3.5 py-1.5 text-xs font-sans rounded transition-colors ${
                danger
                  ? 'bg-red-400/15 text-red-400 hover:bg-red-400/25'
                  : 'bg-accent/15 text-accent hover:bg-accent/25'
              }`}
            >
              {confirmLabel}
            </button>
          </div>
        </Dialog.Content>
      </Dialog.Portal>
    </Dialog.Root>
  );
}
